import styled from 'styled-components';
import { Skeleton } from '@comeon/ui';
import { SMALLER_TERMS_HEIGHT, BIGGER_TERMS_HEIGHT, calcCarouselHeight } from './casino-constants.js';
import { BANNER_HEIGHTS } from '../../banner/config';

export const CarouselContainer = styled.div`
	min-height: ${props => calcCarouselHeight(props)};
`;

const HeroCarouselSkeleton = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledSkeleton = styled(Skeleton)`
	flex-grow: 1;
`;

const CasinoCarouselSkeleton = ({ isSmall = true, isTermsConditionsEnabled = true, height }) => (
	<HeroCarouselSkeleton>
		{height ? (
			<Skeleton height={height} />
		) : (
			<>
				<Skeleton
					height={
						isSmall
							? `${BANNER_HEIGHTS.mobile - SMALLER_TERMS_HEIGHT}px`
							: `${BANNER_HEIGHTS.desktop - BIGGER_TERMS_HEIGHT}px`
					}
				/>
				{isTermsConditionsEnabled && (
					<StyledSkeleton height={isSmall ? `${SMALLER_TERMS_HEIGHT}px` : `${BIGGER_TERMS_HEIGHT}px`} />
				)}
			</>
		)}
	</HeroCarouselSkeleton>
);

export default CasinoCarouselSkeleton;
